// Standard CRA service worker registration (https://cra.link/PWA).
// SW only activates in production builds — dev server skips it by design.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service worker. ' +
              'To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  // ── Actualización automática al cargar ──────────────────────────────────────
  // Antes cada deploy quedaba "waiting" hasta que el usuario tocara el banner
  // o cerrara TODAS las pestañas — en la práctica se seguía usando el build
  // viejo por días (bug real del 2026-07-21: el fundador probó tres deploys
  // seguidos sin tener los cambios en pantalla). Ahora, si la actualización se
  // detecta al abrir la app (ventana de 15 s), se aplica sola: SKIP_WAITING al
  // SW en espera y UNA recarga cuando toma control. Pasada la ventana (check
  // de las 24 h del navegador, con la enfermera a mitad de turno) NO se
  // recarga bajo sus pies: queda el banner manual de siempre.
  const cargadoEn = Date.now();
  const puedeAuto = () => Date.now() - cargadoEn < 15000;
  let aplicamos = false;
  let recargando = false;

  // Solo recarga si ESTA pestaña pidió el cambio de SW: el claim del primer
  // install (controller null → SW) y los updates aplicados desde otra pestaña
  // no deben botar a quien está trabajando aquí.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!aplicamos || recargando) return;
    recargando = true;
    window.location.reload();
  });

  const aplicar = (registration) => {
    if (!registration.waiting) return;
    aplicamos = true;
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Update que quedó esperando de una sesión anterior: aplícalo al tiro.
      if (registration.waiting && navigator.serviceWorker.controller && puedeAuto()) {
        aplicar(registration);
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (puedeAuto()) {
                aplicar(registration);
                return; // sin banner: la página se recarga sola en ~1 s
              }
              window.dispatchEvent(new CustomEvent('swUpdateAvailable', { detail: registration }));
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('html') !== -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
